package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun ScryingMetadata() {
    SpellMetadata(
        spellIndex = "scrying",
        castingTime = "10 minutes",
        range = "Self",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A focus worth at least 1,000 gp, such as a crystal ball, a silver mirror, or a font filled with holy water.",
        duration = "Up to 10 minutes",
        damageBase = null,
        damageScaling = null,
        savingThrow = "WIS (None)",
        aoe = null,
        concentration = true
    )
}
